import PropTypes from 'prop-types';
import React from 'react';
import VideoPlayer from './VideoPlayer';
import AudioPlayer from './AudioPlayer';
import ImagePlayer from './ImagePlayer';

const MediaPlayer = ({
  project,
  zoom = true,
  staffPicks = true,
  user,
  onZoom,
  onLoad,
  clientPreviewUrl = null,
}) => {
  // Check if any streams exist, and if not default to image
  if (project) {
    const stream = project.stream;
    const isProcessing = project.state === 'processing';
    const hasVideoStream =
      stream &&
      typeof stream === 'object' &&
      !Array.isArray(stream) &&
      stream.video &&
      Object.keys(stream.video).length > 0;
    const hasAudioStream =
      stream &&
      typeof stream === 'object' &&
      !Array.isArray(stream) &&
      stream.audio &&
      Object.keys(stream.audio).length > 0;

    if (project.mediaType === 'video' && hasVideoStream && !isProcessing) {
      return (
        <VideoPlayer
          project={project}
          staffPicks={staffPicks}
          user={user}
          onLoad={onLoad}
        />
      );
    }

    if (project.mediaType === 'audio' && hasAudioStream && !isProcessing) {
      return (
        <AudioPlayer
          project={project}
          staffPicks={staffPicks}
          user={user}
          onLoad={onLoad}
        />
      );
    }

    if (
      project.mediaType === 'image' ||
      project.mediaType === 'other' ||
      project.mediaType === 'video' ||
      project.mediaType === 'audio'
    ) {
      return (
        <ImagePlayer
          project={project}
          zoom={zoom}
          staffPicks={staffPicks}
          onZoom={onZoom}
          onLoad={onLoad}
          user={user}
          clientPreviewUrl={clientPreviewUrl}
          showDisabledPlay={project.mediaType === 'video' && isProcessing}
        />
      );
    }
  }

  return <noscript />;
};

MediaPlayer.propTypes = {
  project: PropTypes.object,
  zoom: PropTypes.bool,
  staffPicks: PropTypes.bool,
  user: PropTypes.object,
  onZoom: PropTypes.func,
  onLoad: PropTypes.func,
  clientPreviewUrl: PropTypes.string,
};

export default MediaPlayer;
